
import Vue from "vue";
import { data } from "../App.vue";
import GameDisplay from "./GameDisplay.vue";

export default Vue.extend({
  name: "HowToPlay",
  components: {
    GameDisplay,
  },
  computed: {
    tutorialOverrideSeaLevel: {
      cache: false,
      get(): number {
        if (this.tutorialState == 7) {
          return 4;
        }
        return 0;
      },
    },
  },
  data() {
    return {
      tutorialState: 1,
    };
  },
  methods: {
    clickedBack() {
      if (this.tutorialState <= 1) {
        this.clickedSkip();
        return;
      }
      this.tutorialState--;
      data.clickCount++;
    },
    clickedSkip() {
      data.transitionCount++;
      this.$emit("finished-tutorial");
    },
    clickedNext() {
      if (this.tutorialState >= 7) {
        this.clickedSkip();
        return;
      }
      this.tutorialState++;
      data.clickCount++;
    },
  },
});
